import { createUseStyles } from "react-jss";
import { colors } from "../../constants/colors";
import { breakpoints } from "../../constants/breakpoints";

const styles = createUseStyles({
  banner: {
    display: "flex",
    padding: "12px",
    gap: "12px",
    borderRadius: "12px",
    border: `1px solid ${colors.primary300Blue}`,
    margin: "32px 0px 32px 0px",
    background: colors.primary25Blue,
    boxShadow: "0px 12px 16px -4px rgba(16, 24, 40, 0.08), 0px 4px 6px -2px rgba(16, 24, 40, 0.03)",
    [`@media (max-width: ${breakpoints.md}px)`]: {
      padding: "16px",
    },
  },
  bannerContent: {
    display: "flex",
    alignItems: "flex-start",
    gap: "12px"
  },
  pendingInvitesBtn: {
    padding: "10px 16px",
    alignItems: "center",
    marginLeft: "auto",
    height: "fit-content",
    alignSelf: "center",
    "& span": {
      whiteSpace: "nowrap"
    },
  },
  icon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexBasis: "40px",
    flexShrink: 0,
    borderRadius: "28px",
    background: colors.primary100Blue,
    width: "40px",
    height: "40px",
    margin: "4px",
  },
  bannerTextContainer: {
    display: "flex",
    gap: "6px",
    alignItems: "center",
    minHeight: "48px",
    [`@media (max-width: ${breakpoints.xl}px)`]: {
      flexDirection: "column",
      alignItems: "flex-start",
      gap: "2px",
    }
  },
  bannerTitle: {
    color: colors.primary700Blue,
    fontSize: "16px",
    fontWeight: "600",
    lineHeight: "24px",
    minHeight: "48px",
    alignSelf: "flex-start",
    alignContent: "center",
    wordBreak: "break-word",
    [`@media (max-width: ${breakpoints.md}px)`]: {
      minHeight: "unset",
    },
  },
  message: {
    color: colors.primary700Blue,
    fontSize: "16px",
    fontWeight: "400",
    lineHeight: "24px",
    paddingRight: "16px",
    wordBreak: "break-word",
    [`@media (max-width: ${breakpoints.md}px)`]: {
      paddingRight: "unset",
    },
  },
  closeIcon: {
    margin: "12px",
    marginLeft: "auto",
    flexBasis: "20px",
    flexShrink: 0,
    cursor: "pointer",
  },
  noButtonPresent: {
    marginLeft: "auto !important"
  }
});

export default styles;